/* src/app/FW/controls/durationpicker-entry/durationw-time-dialog/durationw-time-dialog.component.scss */
.w-timepicker-dialog {
  padding: 0;
  margin: -24px;
  width: calc(100% + 48px);
}
/*# sourceMappingURL=durationw-time-dialog.component.css.map */
